angular.module('ui.order.orderItemsGrid', [
    'ui.order.orderItemCard.orderItemGridActions',
    'kendo.directives'
])

    .directive('orderItemsGrid', function () {
        return {
            restrict: "E",
            templateUrl: 'app/ui/order/orderItemsGridView/orderItemsGrid/orderItemsGrid.html',
            scope: {},
            controller: 'OrderItemsGridController',
            controllerAs: 'OrderItemsGridController'
        };
    })

    .controller('OrderItemsGridController', function ($timeout, $window, $rootScope, $scope, $element, $compile, $q, $log, $sce, $state, gettextCatalog, toastr,
        $customisationConfig, usersRepository,
        serverLocalization, uiLocalization, customResourceResolver,
        workflowRepository, orderItemsGridSharedSettings, reportManager,
        gridDataProvider, templateResolver, orderItemsRepository, 
        orderItemsGridControllerUpdatesService,
        barcodeScannerListenerService) {

        $scope.selectedOrderItem = null;
        $scope.selectedOrderItemId = null;

        var textSearchTrigger = false;
        var dataRequestCount = 0;

        //Indicates we were requested for a version of the view without navbar menu on the left
        //Usually this is necessary for a customer view when this view embedded into other software
        $scope.hidemenu = $state.params.hidemenu && $state.params.hidemenu === 'true';

        //Subscribe to barcode scanner events
        var barcodeScannerUnsubscribe = barcodeScannerListenerService.events.on('valueScanned', checkBarcode);

        _.extend($scope, {
            setBusyState: setBusyState,
            reloadGrid: reloadGrid,
            resetOrderItemsGridSharedSettings: resetOrderItemsGridSharedSettings,
            applyTextSearch: applyTextSearch,
            getSelectedEntities: getSelectedEntities,
            showStepDetails: showStepDetails,
            executeAction: executeAction,
            getSelectedOrderItemsCount: getSelectedOrderItemsCount,
            getSelectionInfoLabel: getSelectionInfoLabel
        });

        initController();
        initWatchers();

        /**
         * Controller initialization
         */
        function initController() {
            $scope.isBusy = false;
            $scope.step = orderItemsGridSharedSettings.getStepFilter() || 'all-open';
            
            //clear any remembered search filter for 'All Items' view if 
            //it's not the searching from the main app header searchbox
            if ($scope.step === 'all-open' && !$state.params.search) {
                orderItemsGridSharedSettings.setTextSearch(null);
            }

            //clear any remembered selected items if we re-visit the items grid
            orderItemsGridSharedSettings.setSelectedOrderItemIds([]);

            initAdditionalFilter();
            initTitle();
            initGrid();
            initReportList();
            initModalDialog();
        }    

        function initModalDialog() {
            $scope.getWorkflowActionConfirmationLabel = function () {
                var message = getSelectedOrderItemsCount() > 1
                    ?
                    uiLocalization.translate('Are you sure to apply the action to all selected <b>%s</b> items?', getSelectedOrderItemsCount())
                    :
                    uiLocalization.translate('Are you sure to apply the action to the selected item?');
                return $sce.trustAsHtml(message);
            };

            $scope.confirmActionDialogOptions = {
                //buttonLayout: "normal"
            };

            $scope.actions = [
                {
                    text: uiLocalization.translate('Yes'),
                    primary: true,
                    action: function (e) {
                        executeActionConfirmed(e);
                    }
                },
                {
                    text: uiLocalization.translate('No'),
                    action: function (e) {
                    }
                }
            ];
        }

        function initGridBehaviorConfig() {
            //overrides the url params according to the customization config
            return customResourceResolver.resolveConfig('shell-config')
                .then(function (shellConfig) {
                    if (shellConfig) {
                        $scope.hidemenu = shellConfig.hideMenu === true;
                        $scope.forbidOrderDetailsView = shellConfig.forbidOrderDetailsView === true;
                    }
                });
        }

        function initAdditionalFilter() {
            $scope.searchDropdownOptions = {
                dataSource: [
                    { text: gettextCatalog.getString("Regular Search"), value: "reg-search", icon: "search-dropdown-icon icon-magnifier-add" },
                    { text: gettextCatalog.getString("Exact Match Search"), value: "exact-search", icon: "search-dropdown-icon icon-magnifier" }
                ],
                valuePrimitive: false,
                dataTextField: "text",
                dataValueField: "value",
                valueTemplate: ' ',
                template: '<span class="k-state-default"><i class="{{dataItem.icon}} pull-left"></i>' +
                    '<span>{{dataItem.text}}</span></span>',
                dataBound: function () {
                    this.list.width("auto");
                }
            };

            $scope.clearSearchTerm = function () {
                orderItemsGridSharedSettings.setTextSearch(null);
                $scope.textSearch = null;
                applyTextSearch();
            };

            var textSearchConfig = orderItemsGridSharedSettings.getTextSearch();
            if (textSearchConfig) {
                $scope.textSearch = textSearchConfig.text;
                $scope.searchDropdown = textSearchConfig.exact ? "exact-search" : "reg-search";
            } else {
                $scope.textSearch = null;
                $scope.searchDropdown = "reg-search";
            }
        }

        function initDatesFilter() {

            //TODO: if $scope.gridConfig.showCalendarFromToDates -- configure orderItemsGridSharedSettings 


            var completedFilterConfig = orderItemsGridSharedSettings.getCompletedFilter();
            var createdFilterConfig = orderItemsGridSharedSettings.getCreatedFilter();

            if (completedFilterConfig) {
                //showCompletedFilter flag value controled by kendo-switch when turned ON by user
                //This kendo-switch will be shown in the UI if gridConfig.hideShowCompletedSwitch == false
                $scope.showCompletedFilter = !!completedFilterConfig.enabled;
                var now = new Date();
                var oneMonthAgo = new Date();
                oneMonthAgo.setMonth(now.getMonth() - 3); //Let's try 3 month ago
                $scope.datePickerFrom = completedFilterConfig.from || oneMonthAgo;
                $scope.datePickerTo = completedFilterConfig.to || now;
                //Now allow the filter to be shown only for 'all-open' stage
                $scope.showCompletedFilter = $scope.step === 'all-open' && !!completedFilterConfig.enabled;
            }

            if (createdFilterConfig || !!$scope.gridConfig.useCreatedDateFilter) {
                //gridConfig.useCreatedDateFilter - used to control usage of the order created date filtering.
                //Dates filtering controls will be shown if gridConfig.useCreatedDateFilter == true
                $scope.useCreatedDateFilter = !!$scope.gridConfig.useCreatedDateFilter;
                var now = new Date();
                var oneMonthAgo = new Date();
                oneMonthAgo.setMonth(now.getMonth() - 3); //Let's try 3 month ago
                $scope.datePickerFrom = createdFilterConfig && createdFilterConfig.from ? createdFilterConfig.from : oneMonthAgo;
                $scope.datePickerTo = createdFilterConfig && createdFilterConfig.to ? createdFilterConfig.to : now;
            }

            if (!completedFilterConfig && !$scope.useCreatedDateFilter) {
                $scope.showCompletedFilter = false;
                $scope.datePickerFrom = null;
                $scope.datePickerTo = null;
            }
            completedDateChanged();
        }

        function completedDateChanged() {
            orderItemsGridSharedSettings.setCompletedFilter({
                from: $scope.datePickerFrom,
                to: $scope.datePickerTo,
                enabled: !!$scope.showCompletedFilter
            });
            orderItemsGridSharedSettings.setCreatedFilter({
                from: $scope.datePickerFrom,
                to: $scope.datePickerTo,
                enabled: !!$scope.useCreatedDateFilter
            });
        }

        /**
         * Initialize watchers (call only one time!)
         */
        function initWatchers() {

            $scope.$watch('datePickerFrom', completedDateChangedHandler);
            $scope.$watch('datePickerTo', completedDateChangedHandler);
            $scope.$watch('showCompletedFilter', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    if (newVal === true && !$scope.datePickerFrom && !$scope.datePickerTo) {
                        var now = new Date();
                        var oneMonthAgo = new Date();
                        oneMonthAgo.setMonth(now.getMonth() - 3); //Let's try 3 month ago
                        $scope.datePickerFrom = oneMonthAgo;
                        $scope.datePickerTo = now;
                    }
                    completedDateChanged();
                    reloadGrid();
                }
            });
            initSignalREvents();

            $scope.$on(
                "$destroy",
                function () {
                    destroyGrid();
                    orderItemsGridControllerUpdatesService.onOrderItemChanged(null);
                    orderItemsGridControllerUpdatesService.onNewOrderItem(null);
                    orderItemsGridControllerUpdatesService.onOrderChanged(null);
                    barcodeScannerUnsubscribe();
                }
            );

            function completedDateChangedHandler(newVal, oldVal) {
                if (!_.isEqual(newVal, oldVal)) {
                    completedDateChanged();
                    if ($scope.showCompletedFilter === true || !!$scope.useCreatedDateFilter) {
                        reloadGrid();
                    }
                }
            }
        }

        /**
         * Init the view title depending on the current user, current selected step
         * @returns {Promise}
         */
        function initTitle() {
            $scope.totalItemsCountForPageTitle = 0;

            return $q.all([
                usersRepository.getCurrentUser(),
                workflowRepository.getSteps(),
                customResourceResolver.resolveWorkflow()
            ])
                .then(function (data) {
                    var currentUser = data[0];
                    var steps = data[1];
                    var workflowConfig = data[2];

                    var currentStepCode = orderItemsGridSharedSettings.getStepFilter();

                    if (currentStepCode && currentStepCode !== "all-open") {
                        var isCustomer = currentUser.isCustomer();
                        var step = _.find(steps, function (s) {
                            return s.$model.code.toLowerCase() === currentStepCode.toLowerCase();
                        });

                        var stepConfig = _.find(workflowConfig.steps, function (s) {
                            return s.code === currentStepCode;
                        });
                        var stepDisplayName = isCustomer ? step.$model.publicNameResource : step.$model.nameResource;

                        $scope.viewTitle = serverLocalization.translate(stepDisplayName);
                        $scope.viewIconName =
                            angular.isUndefined(stepConfig)
                                ? getFallbackIconForStep(step.$model.code)
                                : (angular.isDefined(stepConfig.publicImageResourceName) && isCustomer
                                    ? stepConfig.publicImageResourceName : (angular.isDefined(stepConfig.imageResourceName)
                                        ? stepConfig.imageResourceName
                                        : getFallbackIconForStep(step.$model.code)));

                        function getFallbackIconForStep(stepCode) {
                            return $customisationConfig.hasResource(function (res) {
                                return _.string.contains(res, stepCode + ".");
                            }) ? stepCode : "workflow";
                        }
                    } else {
                        //See if we have custom filter applied
                        var customFilter = orderItemsGridSharedSettings.getCustomFilter();
                        if (customFilter) {
                            $scope.viewTitle = gettextCatalog.getString(customFilter.name || "Filtered Items");
                            $scope.viewIconName = customFilter.iconName || "track"; //'track' icon as a default one if no custom specified
                        } else {
                            $scope.viewTitle = gettextCatalog.getString("All Items");
                            $scope.viewIconName = "track";
                        }
                    }

                    updatePageTitle();

                }, function (error) {
                    if (error && error.message) {
                        $log.error(error.message);
                    } else if (error && _.isString(error)) {
                        $log.error(error);
                    } else {
                        $log.error("Unknown error. Can't initialize grid title.");
                    }
                });
        }

        /**
         * Initialize grid
         * @returns {Promise}
         */
        function initGrid() {

            angular.element($window).bind('resize', function () {
                resizeGrid();
                // manual $digest required as resize event
                // is outside of angular
                $scope.$digest();
            });

            $q.all([
                gridDataProvider.getGridConfig($scope.step),
                templateResolver.resolve('app/ui/order/orderItemsGridView/orderItemsGrid/gridHeader.html'),
                initGridBehaviorConfig()
            ]).then(function (data) {
                var gridConfig = _.clone(data[0]);
                var gridHeaderTemplate = data[1];

                gridConfig = initGridConfig(gridConfig, gridHeaderTemplate);
                gridConfig.dataSource = initGridDataSource(gridConfig);
                $scope.gridConfig = gridConfig;

                //Init dates filtering controls in the grid header (we need to do it from here to make sure we have grid config available )
                //Before we compile grid into the view
                initDatesFilter();

                var gridTemplate = '<div id="orderItemsGrid" kendo-grid="orderItemsGrid" k-options="gridConfig" class="all-open-grid k-grid-content"></div>';
                var jqTemplate = $('#orderItemsKendoGrid').append(gridTemplate);
                $compile(jqTemplate)($scope);

                //Init all the handlers for the events of the grid (like row click, checkbox-selector click, ,double-click, etc.
                initGridEventsHandlers(gridConfig);

                //Trigger window resize event to properly resize grid
                $timeout(function () { $(window).trigger('resize'); });
            },
                function (error) {
                    $log.error("Can't initialize grid: ");
                    if (error && error.message) {
                        $log.error(error.message);
                    } else if (error && _.isString(error)) {
                        $log.error(error);
                    } else {
                        $log.error("Unknown error");
                    }
                });
        }

        function resizeGrid() {
            var availableHeight = $(window).height() - $("div.grid-view-title").height() 
                - $("div.k-grid-toolbar").outerHeight(true) - $("thead.k-grid-header").outerHeight(true) - $("div.k-grouping-header").outerHeight(true) 
                - $("div.k-grid-pager").outerHeight(true) - $("#header").outerHeight(true);

            $('#orderItemsKendoGrid table').css("height", availableHeight);
        }

        function destroyGrid() {
            if (!$scope.orderItemsGrid || !$scope.orderItemsGrid.destroy) {
                return;
            }
            $scope.orderItemsGrid.destroy();
        }

        var hasItemsSelectedOnOtherPages = false;
        var isSingleRowClick = false;

        function initGridEventsHandlers(gConfig) {
            //double click event to allow user to open order details
            $("#orderItemsKendoGrid tbody[role='rowgroup']").on("dblclick", "tr", function () {
                isSingleRowClick = true;
                showStepDetails();
            });

            //Handle the checkboxes clicks to select items (as if the 'Ctrl' pressed)
            $("#orderItemsKendoGrid tbody[role='rowgroup']").on("click", "tr", function (e) {
                isSingleRowClick = false;
                $('tbody tr').find('input[type=checkbox]').prop('checked', false);
                $('tbody tr.k-state-selected').find('input[type=checkbox]').prop('checked', true);

                if (!$(e.target).hasClass("row-selector")) {
                    //if it's not label nor checkbox of the row selector which should act as 'add to selection'
                    //we need to act as it's just a signle row selection to reset the previously selected items
                    isSingleRowClick = !e.shiftKey && !e.ctrlKey && !$(e.target).hasClass("k-checkbox");
                    return;
                }

                var rowElement = this;
                var row = $(rowElement);
                var grid = $scope.orderItemsGrid;

                hasItemsSelectedOnOtherPages =
                    orderItemsGridSharedSettings.getSelectedOrderItemIds().length > grid.select().length;

                if (row.hasClass("k-state-selected")) {
                    var itemToRemove = grid.dataItem(row);
                    var selected = $.grep(
                        grid.select(),
                        function (x) {
                            return itemToRemove.getId() !== grid.dataItem(x).getId();
                        });
                    //and remove from the saved selection as well
                    orderItemsGridSharedSettings.setSelectedOrderItemIds(
                        _.filter(orderItemsGridSharedSettings.getSelectedOrderItemIds(),
                            function (id) {
                                return id !== itemToRemove.getId();
                            }));

                    grid.clearSelection();
                    grid.select(selected);
                    e.stopPropagation();
                } else {
                    grid.select(row);
                    e.stopPropagation(); //to not trigger default grid selection mechanism
                }
            });

            //And handle 'select-all' action
            $("#orderItemsKendoGrid thead[role='rowgroup']").on("click", "tr", function (e) {
                isSingleRowClick = false;
                $('tbody tr').find('input[type=checkbox]').prop('checked', false); //clear all checkboxes in all rows
                $('tbody tr.k-state-selected').find('input[type=checkbox]').prop('checked', true); //'check' those in the selected rows

                //Get the counts of selected and total items
                var selectedIdsCount = orderItemsGridSharedSettings.getSelectedOrderItemIds().length;
                var totalCount = orderItemsGridSharedSettings.getTotalCount();

                //As we land here after items selected via 'select-all label' click later on the 'checkbox' click event
                //just update the checkbox state here
                if ($(e.target).hasClass("k-checkbox")) {
                    $(e.target).prop('checked', selectedIdsCount === totalCount);
                    $(e.target).prop('indeterminate', selectedIdsCount < totalCount && selectedIdsCount > 0);
                }

                if (!$(e.target).hasClass("all-selector")) {
                    return; //do not perform other actions if it's not the actual 'select-all' label click to avoid duplication
                }

                var grid = $scope.orderItemsGrid;
                var currentPageRowsCount = grid.tbody.find(">tr[role='row']:not(.k-grouping-row)").length;
                var currentPageSelectionCount = grid.select().length;

                if (selectedIdsCount >= currentPageRowsCount) {
                    //See if we have all items selected on the current page
                    //or we items selected on other pages already
                    if (currentPageSelectionCount < currentPageRowsCount) {
                        grid.select(grid.tbody.find(">tr")); //actually visualise in the grid the current page selection
                    } else {
                        if (selectedIdsCount === totalCount) {
                            //So to indicate we need to clear ALL items from selection on subsequent click on 'select-all' checkbox
                            //when we have really ALL items selected by selecting them on each page manually
                            orderItemsGridSharedSettings.setSelectedOrderItemIds([]);
                        } else {
                            //remove from the selection only the items of the current page
                            var itemsToRemove = grid.select();
                            //and remove from the saved selection (we need to filter out items that are selected but are located
                            //on the other grid pages, so we remove only the items that were selected on the current page
                            var updatedSelection = _.filter(orderItemsGridSharedSettings.getSelectedOrderItemIds(),
                                function (id) {
                                    return _.findIndex(itemsToRemove, function (i) {
                                        return grid.dataItem(i).getId() === id;
                                    }) === -1;
                                });
                            orderItemsGridSharedSettings.setSelectedOrderItemIds(updatedSelection);
                        }
                        //Just clear the selection so visually is nothing selected
                        //as we are here 'de-selecting' items
                        grid.clearSelection(); //this call clears selection from the current grid page only
                    }
                } else {
                    //Just select one page
                    grid.select(grid.tbody.find(">tr")); //actually visualise in the grid the current page selection
                }

                e.stopPropagation();
            });
        }

        function initGridConfig(gConfig, gridHeaderTemplate) {
            //TODO: We might want to further refactor the approach to use special term to distinguish the mode 'existing step' or virtual view
            //where 'all-open' is a virtual view just like any other specified for the brand custom config
            //In this case we may end up being able to specify custom config not for the existing steps only, but also for any
            //'virtual view' specified as a custom filter in the configConfigs.js
            //All we would need is to update the method that gets gridConfig for us by resolving it using the 'forStep' variable, which will
            //contain not only either 'all-open' or 'real step name' values, but also 'custom filter' name values. 
            //Currently we use the grid config of 'all-open' for the 'custom filter' views
            if (orderItemsGridSharedSettings.getCustomFilter() !== null) {
                gConfig.hideShowCompletedSwitch = true;
            }

            if (gConfig.hideShowCompletedSwitch && gConfig.hideShowCompletedSwitch === true) {
                orderItemsGridSharedSettings.hideShowCompletedSwitch = true;
            }
            if (gConfig.columns) {
                var firstVisibleColumn = _.find(gConfig.columns, function (c) {
                    return !c.hidden && c.field;
                });
                if (firstVisibleColumn) {
                    firstVisibleColumn.template = _.string.sprintf(
                        "<div style='white-space:nowrap;'><a title='%s' class='fa fa-lg fa-ellipsis-v a-fa-btn details-btn pull-left' ng-click='showStepDetails()'></a><span>#:%s#</span></div>",
                        gettextCatalog.getString("View Details"),
                        firstVisibleColumn.field);
                }

                //Check if we have columns without percentage specified. Assign width if so.
                for (var i = 0; i < gConfig.columns.length; i++) {
                    var column = gConfig.columns[i];
                    if (!column.width) {
                        column.width = 2 * (100 / gConfig.columns.length) + "%";
                    }
                }
            }

            gConfig.toolbar = [{ template: gridHeaderTemplate }];

            gConfig.noRecords = {
                template: gettextCatalog.getString("No items to display")
            };

            gConfig.dataBound = function (e) {
                // For some reason after we compile the grid into the page, it requests data and calls dataBound twice
                // This happens once after grid init so we just need to avoid one duplicated request
                // So to workaround that we skip the second duplicated data request in the datasource.read method
                // and we need to skip the duplicated dataBound execution by skipping it if dataRequestCount less than 2
                if (dataRequestCount < 2) {
                    return;
                }

                //Execute the dataBound defined on the customised config first 
                if (angular.isDefined($scope.gridConfig.dataBoundEventHandler) && angular.isFunction($scope.gridConfig.dataBoundEventHandler)) {
                    try {
                        $scope.gridConfig.dataBoundEventHandler.call($scope.orderItemsGrid, e);
                    } catch (error) {
                        $log.error("Error during executing customised Grid's config's DataBound even handler.", error);
                    }
                }

                //And then mark the already selected rows in the grid so it will be visible to user they are selected
                //upon navigation to the gridview
                var selectedItemsIds = orderItemsGridSharedSettings.getSelectedOrderItemIds();
                if (selectedItemsIds) {
                    _.forEach(selectedItemsIds, function (itemId) {
                        var dataItem = $scope.gridConfig.dataSource.get(itemId);
                        if (dataItem && dataItem.uid) {
                            $scope.orderItemsGrid.select('tr[data-uid="' + dataItem.uid + '"]');
                        }
                    });
                }

                //And highlight the searchTerm found in the text values inside rows shown
                $timeout(function () {
                    if (!String.isNullOrWhiteSpace($scope.textSearch)) {
                        $("#orderItemsKendoGrid tbody td[role='gridcell']").highlight($scope.textSearch);
                    } else {
                        $("#orderItemsKendoGrid tbody td[role='gridcell']").unhighlight();
                    }
                });
            };

            gConfig.change = function (e) {
                var grid = $scope.orderItemsGrid;
                //See which exact items got deselected if any (items which are yet checked but the rows are deselected already)
                var itemsDeselected = _.map($('tbody tr:not(.k-state-selected) input:checked'),
                    function (input) {
                        return grid.dataItem(input.closest('tr'));
                    });

                //Update checkbox if the row selected/deselected
                $('tbody tr').find('input[type=checkbox]').prop('checked', false);
                $('tbody tr.k-state-selected').find('input[type=checkbox]').prop('checked', true);

                //Get currently total selected items on all pages
                var totalSelected = orderItemsGridSharedSettings.getSelectedOrderItemIds();
                //Get selected items on the current page only directly from the grid object
                var selected = getSelectedEntities();

                if (selected && selected[0] && selected[0].isRepresentationModel) {
                    $scope.selectedOrderItemId = selected[0].getId();
                    $scope.selectedOrderItem = selected[0];

                    //Assemble deduplicated list of totally selected items on all pages to save it
                    if (!isSingleRowClick) {
                        //Add items that were selected (ignoring duplicates)
                        totalSelected = _.uniq([].concat(totalSelected, _.map(selected, function (s) {
                            return s.getId();
                        })));
                    } else {
                        totalSelected = [$scope.selectedOrderItemId];
                        isSingleRowClick = false; //reset flag
                    }
                }
                //Remove items that were deselected if any
                if (itemsDeselected && itemsDeselected.length > 0) {
                    totalSelected = _.difference(totalSelected, _.map(itemsDeselected, function (s) {
                        return s.getId();
                    }));
                }

                //we need to trigger dropdown list refresh so it will reevaluate its items templates (Kendo issue :( )
                $scope.reportsDropDown.refresh();

                //Save updated selection
                orderItemsGridSharedSettings.setSelectedOrderItemIds(totalSelected);

                //Get updated values
                var selectedIdsCount = orderItemsGridSharedSettings.getSelectedOrderItemIds().length;
                var totalCount = orderItemsGridSharedSettings.getTotalCount();

                //Update 'select all' checkbox if necessary (if present)
                $('thead tr').find('input[type=checkbox]').prop('checked', selectedIdsCount === totalCount);
                $('thead tr').find('input[type=checkbox]').prop('indeterminate', selectedIdsCount < totalCount && selectedIdsCount > 0);

            };

            //Grid pager is 'ON' by default or if specified so
            if (!gConfig.pageable || typeof gConfig.pageable === 'boolean' || gConfig.pageable !== null) {
                //Pager info (items count) is 'ON' by defaults unless specified to be 'OFF'
                var disablePagerInfo = gConfig.disablePagerItemsInfo && gConfig.disablePagerItemsInfo === true;
                if (disablePagerInfo) {
                    //Reset pageable object. Otherwise just not touch it as it contains other valuable settings
                    gConfig.pageable = {
                        refresh: true,
                        pageSizes: true,
                        info: !disablePagerInfo
                    };
                }
            }

            //See if we have default sorting specified, then set it onto grid shared settings
            if (angular.isDefined(gConfig.initialSort)) {
                if (angular.isArray(gConfig.initialSort)) {
                    orderItemsGridSharedSettings.setGridSort(gConfig.initialSort);
                } else if (angular.isDefined(gConfig.initialSort.field) && angular.isDefined(gConfig.initialSort.dir)) {
                    orderItemsGridSharedSettings.setGridSort([gConfig.initialSort]);
                }
            }


            return gConfig;
        }

        var forcedPageChange = false;
        var cachedResult;

        function initGridDataSource(gridConfig) {
            var dataSourceObj = {
                transport: {
                    read: function (options) {
                        if (forcedPageChange) { // prevent data request after manual page change
                            forcedPageChange = false;
                            if (cachedResult) {
                                options.success(cachedResult);
                            } else {
                                toastr.error(gettextCatalog.getString("Data request cache error"));
                                options.error();
                            }
                            return;
                        }
                        $scope.isBusy = true;

                        //Reset page size ignorance flag as it shouldn't alter grid behavior.
                        //It is applied only on the item details card if order item id specified in the url as a parameter
                        orderItemsGridSharedSettings.setForceIgnorePageSize(false);

                        orderItemsGridSharedSettings.setPageNumber(options.data.page || 1);
                        orderItemsGridSharedSettings.setPageSize(angular.isDefined(options.data.pageSize) ? options.data.pageSize : 20);
                        orderItemsGridSharedSettings.setGridFilter(options.data.filter);
                        orderItemsGridSharedSettings.setGridSort(options.data.sort);

                        // check if we have a duplicated request after grid init
                        // i.e. For some reason after we compile the grid into the page, it requests data
                        // and then requests data again. This happens once after grid init so we just need to avoid one duplicated request
                        if (dataRequestCount === 1 && cachedResult &&
                            $scope.gridConfig.dataSource.page() === options.data.page &&
                            $scope.gridConfig.dataSource.pageSize() === options.data.pageSize) {
                            dataRequestCount++;
                            options.success(cachedResult);
                            $scope.isBusy = false;
                            return;
                        }

                        renderSkeletonPlaceholdersLoadingAnimation();

                        gridDataProvider.getData()
                            .then(function (result) {
                                orderItemsGridSharedSettings.setTotalCount(result.totalCount);
                                orderItemsGridSharedSettings.setTotalPageCount(result.totalPageCount);
                                cachedResult = result;
                                dataRequestCount++;

                                // check if current page number was changed
                                if ($scope.gridConfig.dataSource.page() !== result.pageNumber ||
                                    $scope.gridConfig.dataSource.pageSize() !== result.rowsPerPage) {
                                    forcedPageChange = true;
                                    options.page = result.pageNumber;
                                    options.pageSize = result.rowsPerPage;
                                    $scope.gridConfig.dataSource.query(options);
                                }

                                if (!$scope.selectedOrderItemId) {
                                    $scope.selectedOrderItemId = orderItemsGridSharedSettings.getSelectedOrderItemId();
                                }

                                var ts = orderItemsGridSharedSettings.getTextSearch();
                                if (result.totalCount === 1 && result.items.length === 1) { // if we found one item...
                                    if (ts && ts.text && textSearchTrigger === true) { // ...and search box is not empty...
                                        if (!$scope.forbidOrderDetailsView) { // ...and we are allowed to go into order details
                                            // ...open the item
                                            //
                                            //Commented for now as we will handle the navigation caused by barcode scanner
                                            //in the dedicated handler 'checkBarcode()'
                                            //orderItemsGridSharedSettings.setSelectedOrderItemId(result.items[0].getId());
                                            //$state.go('client.step', {
                                            //    step: $scope.step
                                            //});
                                        }
                                    }
                                } else if (result.totalCount === 0) { // if we found nothing
                                    // todo sound notification
                                    if (ts && ts.text && textSearchTrigger === true) {
                                        // select search text box
                                        $($element).find("#gridTextSearchField").select();
                                    }
                                }

                                clearSkeletonPlaceholdersLoadingAnimation();

                                $scope.totalItemsCountForPageTitle = result.totalCount;
                                updatePageTitle();

                                options.success(result);
                                $scope.isBusy = false;
                                textSearchTrigger = false;
                            },
                                function (resp) {
                                    textSearchTrigger = false;
                                    if (resp && resp.status) {
                                        toastr.error(resp.message, gettextCatalog.getString("Data request failed"));
                                    } else {
                                        toastr.error(gettextCatalog.getString("Data request failed"),
                                            gettextCatalog.getString("Server is not responding"));
                                    }
                                    options.error();
                                    $scope.isBusy = false;
                                });
                    }
                },
                schema: {
                    data: function (response) {
                        return response ? response.items : null;
                    },
                    total: function (response) {
                        return response ? response.totalCount : 0;
                    },
                    model: {
                        id: "$model.id",
                        fields: gridConfig.fields || {}
                    }
                },
                page: orderItemsGridSharedSettings.getPageNumber() || 1,
                pageSize: orderItemsGridSharedSettings.getPageSize() || gridConfig.pageSize || 20,
                filter: orderItemsGridSharedSettings.getGridFilter(),
                sort: orderItemsGridSharedSettings.getGridSort(),
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true
            };

            if (gridConfig.groupable == true && angular.isDefined(gridConfig.initialGroup)) {
                dataSourceObj.group = gridConfig.initialGroup;
                dataSourceObj.pageSize = gridConfig.pageSize;
            }

            return new kendo.data.DataSource(dataSourceObj);
        }

        function updatePageTitle() {
            //And update the browser tab page title
            $rootScope.pageTitle =
                gettextCatalog.getString('OrderManager: ') + $scope.viewTitle + 
                ($scope.totalItemsCountForPageTitle > 0 ? (': ' + $scope.totalItemsCountForPageTitle) : '');
        }

        function renderSkeletonPlaceholdersLoadingAnimation() {
            if ($('#orderItemsKendoGrid table tbody').children().length > 0 || $('#orderItemsKendoGrid div.k-grid-norecords').length > 0) {
                //Do not render skeleton loading placeholders if we do have records to show OR if instead there are no records to show and we alreayd know it
                return;
            }

            var pageSize = orderItemsGridSharedSettings.getPageSize();
            if (!angular.isDefined(pageSize)) {
                pageSize = $scope.gridConfig.pageSize;
            }

            if (pageSize === 0 || pageSize > 15) {
                pageSize = 15; //Set page size for the loading-placeholders content to 15 if it's configured for bigger value or 0 which is 'show all'
            }

            var columnsCount = 10; //10 by default but it's better to try and find the columns count from grid template
                                   //which is initialised based on the grid branded config
            if ($('#orderItemsKendoGrid table colgroup').length > 0) {
                columnsCount = $('#orderItemsKendoGrid table colgroup').children().length;
            }
            for (var i = 0; i < pageSize; i++) {

                //Render visual templates to indicate loading rows/cells
                var row = $('<tr></tr>');
                for (var c = 0; c < columnsCount; c++) {
                    var divWidth = c > 0 ? (40 + Math.floor(Math.random() * 60)) : 100;
                    row.append($('<td class="loading-td"><div style="width:' + divWidth + '%;"></div></td>'));
                }
                $('#orderItemsKendoGrid table tbody').append(row);

            }
        }

        function clearSkeletonPlaceholdersLoadingAnimation() {
            $('#orderItemsKendoGrid table tbody').empty();
        }

        function initSignalREvents() {
            var reloadGridBySignalREvent = _.debounce(function (e) {
                reloadGrid();
            }, 500);

            orderItemsGridControllerUpdatesService.onOrderItemChanged(reloadGridBySignalREvent);
            orderItemsGridControllerUpdatesService.onNewOrderItem(reloadGridBySignalREvent);
            orderItemsGridControllerUpdatesService.onOrderChanged(reloadGridBySignalREvent);
        }

        /**
         * Reports DropDown initialization
         * @returns {Promise}
         */
        function initReportList() {
            return reportManager.getReportList(orderItemsGridSharedSettings.getStepFilter())
                .then(function (results) {
                    var reportComboItems = [];
                    _.forEach(results, function (value) {
                        reportComboItems.push({
                            "text": value.name,
                            "value": value
                        });
                    });
                    $scope.dropdownReportsOptions = {
                        dataSource: reportComboItems,
                        dataTextField: "text",
                        dataValueField: "value",
                        height: "auto",
                        valueTemplate: gettextCatalog.getString("Reports"),
                        template: "<span class='k-state-default'  # if (!!data.value.requiresSelection) { # ng-class='{\"k-state-disabled\": selectedOrderItemId == null}' # } #><span>{{dataItem.text|sTranslate}}</span></span>",
                        select: function (e) {
                            gridDataProvider.getReportQuery() //acquire the current query used to populate the grid
                                .then(function (gridQuery) {
                                    var report = $scope.dropdownReportsOptions.dataSource[e.item.index()]; //get the clicked report configuration
                                    var selectedItemId = orderItemsGridSharedSettings.getSelectedOrderItemId(); //see if we have a selected item

                                    if (!!report.value.requiresSelection) {
                                        if (angular.isDefined(selectedItemId)) {
                                            //we use the selected item id as a query for the report if we have one selected
                                            reportManager.show({
                                                report: report.value,
                                                query: [selectedItemId],
                                                orderBy: report.value.orderBy || gridQuery.orderBy
                                            });
                                        }
                                        //do nothing if report requires selection and we don't have any item selected
                                    } else {
                                        //If report doesn't require selection, use either specific custom query of the report (report.value.query)
                                        //specified in customisation or just the query that is used to show the current data set (gridQuery.query)
                                        //user is being viewing at.
                                        //Query and orderBy from report specified in customisation have higher priority over current-context data.
                                        reportManager.show({
                                            report: report.value,
                                            //Now supply the query to the report manager. Here we check if the report was configured with static query,
                                            //dynamic (function) query or no query at all. If it is a dynamic query - we use it, otherwise we use static query.
                                            //In case no query was configured in the report configuration section, we just use the grid's query to generate
                                            //report for exactly the same items we see in the grid.
                                            query: angular.isFunction(report.value.query)
                                                ? report.value.query(gridQuery, $scope.selectedOrderItem)
                                                : (report.value.query || gridQuery.query),
                                            orderBy: report.value.orderBy || gridQuery.orderBy
                                        });
                                    }
                                });
                        },
                        dataBound: function () {
                            this.list.width('auto');
                        }
                    };
                }, function (error) {
                    $log.error("Can't initialize report list: ");
                    if (error && error.message) {
                        $log.error(error.message);
                    } else if (error && _.isString(error)) {
                        $log.error(error);
                    } else {
                        $log.error("Unknown error");
                    }
                });
        }

        function getSelectionInfoLabel() {
            return uiLocalization.translate('You have %s items selected', getSelectedOrderItemsCount());
        }

        function getSelectedOrderItemsCount() {
            return orderItemsGridSharedSettings.getSelectedOrderItemIds().length;
        }

        /**
         * Get selected items from grid
         * @returns {!RepresentationModel[]}
         */
        function getSelectedEntities() {
            var selectedEntities = [];
            var selectedDOM = $scope.orderItemsGrid.select();
            _.forEach(selectedDOM, function (value) {
                selectedEntities.push($scope.orderItemsGrid.dataItem(value));
            });
            return selectedEntities;
        }

        /**
         * Go to the Step Details View
         */
        function showStepDetails() {
            var selected = getSelectedEntities();
            if (!selected || $scope.forbidOrderDetailsView) {
                //Do not allow to go into step details if nothing selected
                //OR if we are requested to do so according to the customisation configs
                return;
            }
            var firstSelected = selected[0];
            if (firstSelected && firstSelected.isRepresentationModel) {
                orderItemsGridSharedSettings.setSelectedOrderItemId(firstSelected.getId());
                // go to the Step Details View
                $state.go('client.step', {
                    step: $scope.step
                });
            }
        }

        /**
         * Apply text search
         */
        function applyTextSearch() {
            orderItemsGridSharedSettings.setTextSearch($scope.textSearch, $scope.searchDropdown === "exact-search");
            reloadGrid();
            textSearchTrigger = true;
        }

        /**
         * Handle barcode scanner value scanned
         */
        function checkBarcode(e) {
            //See if the scanned value corresponds to any valid order item Id of any item on the currently 
            //being shown step, then select that item and redirect to the 'detailed' view
            if (e.value.length > 0) {
                orderItemsGridSharedSettings.setTextSearch(e.value, true);
                reloadGrid().then(function () {
                    if ($scope.orderItemsGrid && $scope.orderItemsGrid.dataItem("tbody tr:eq(0)") != null &&
                        (e.value == $scope.orderItemsGrid.dataItem("tbody tr:eq(0)").getId() ||
                            e.value == $scope.orderItemsGrid.dataItem("tbody tr:eq(0)").$model.order.getId())) {
                        //set the very first item as a selected one
                        orderItemsGridSharedSettings.setSelectedOrderItemId($scope.orderItemsGrid.dataItem("tbody tr:eq(0)").getId());
                        $state.go('client.step', { step: $scope.step });
                        orderItemsGridSharedSettings.setTextSearch(e.value, $scope.searchDropdown === "exact-search");
                    } else {
                        //Nothing found so just reset search and refresh grid
                        var snd = new Audio("data:audio/wav;base64,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");
                        snd.play();
                        toastr.warning(gettextCatalog.getString('There are no items corresponding to the scanned barcode [' + e.value + '].'), gettextCatalog.getString('Nothing found :('));
                        textSearchTrigger = false;
                        orderItemsGridSharedSettings.setTextSearch('', $scope.searchDropdown === "exact-search");
                        reloadGrid();
                    }
                });
            }
        }

        /**
         * Force grid to refresh (if loaded)
         */
        function reloadGrid() {

            if ($scope.orderItemsGrid && $scope.orderItemsGrid.dataSource && $scope.orderItemsGrid.dataSource.read) {
                $('thead tr').find('input[type=checkbox]').prop('checked', false);
                $('thead tr').find('input[type=checkbox]').prop('indeterminate', false);

                return $scope.orderItemsGrid.dataSource.read();
            }

            return $q.when(null);
        }

        /**
         * Updates busy state
         */
        function setBusyState(newBusyState) {
            $scope.isBusy = newBusyState;
        }

        function resetOrderItemsGridSharedSettings() {
            //The below code used by the external helper methods which operate on the items in the grid
            //to clear selection and current page
            orderItemsGridSharedSettings.setSelectedOrderItemIds([]);
            orderItemsGridSharedSettings.setPageNumber(1);
        }

        /**
         * Executes selected action for the selected items
         */
        function executeAction(actionToExecute) {

            var selectedItemsIds = orderItemsGridSharedSettings.getSelectedOrderItemIds();
            if (!actionToExecute || $scope.isBusy || !selectedItemsIds || selectedItemsIds.length === 0) {
                return;
            }

            $scope.actionToExecute = actionToExecute;
            $scope.confirmActionDialog.open();
        }

        function executeActionConfirmed(e) {
            $scope.isBusy = true;
            var currentStep = $scope.step;

            onBeforeActionExecute(e)
                .then(function () {
                    workflowRepository
                        .executeActionForOrderItems(currentStep, $scope.actionToExecute, orderItemsGridSharedSettings.getSelectedOrderItemIds())
                        .then(function (resp) {
                            $log.debug('Executed action [' + $scope.actionToExecute + '] for selected ' + getSelectedOrderItemsCount() + ' items.');
                            var itemsCount = orderItemsGridSharedSettings.getSelectedOrderItemIds().length;
                            var itemsMsg = itemsCount ?
                                uiLocalization.translate("%s item has been progressed to [%s].", orderItemsGridSharedSettings.getSelectedOrderItemIds().length, $scope.actionToExecute) :
                                uiLocalization.translate("%s items have been progressed to [%s].", orderItemsGridSharedSettings.getSelectedOrderItemIds().length, $scope.actionToExecute);
                            var buttonHtml = _.str.sprintf(
                                '<div class="toast-button-row"><a href="#/client/home" style="float:right;" class="toast-button">%s&nbsp;<i class="fa fa-external-link-square" /></a></div>',
                                uiLocalization.translate("Go to Overview"));

                            toastr.info(_.str.sprintf('%s %s', itemsMsg, buttonHtml), uiLocalization.translate("Action execution completed"));

                            //Now we can reset the selected items, page number and grid
                            orderItemsGridSharedSettings.setSelectedOrderItemIds([]);
                            orderItemsGridSharedSettings.setPageNumber(1);
                            $scope.orderItemsGrid.dataSource.page(1);
                            reloadGrid().then(function () {
                                $scope.actionToExecute = '';
                                $scope.isBusy = false;
                            });
                        },
                        function (error) {
                            if (error) {
                                var em = error.serverErrorMessage || error.message;
                                toastr.error(uiLocalization.translate("Action execution error! Error details: %s", em));
                                $log.error("Action execution error: \n" + em);
                                $scope.isBusy = false;
                            }
                            return $q.reject(null);
                        });
                });
        }

        function onBeforeActionExecute(e) {
            if (!$scope.gridConfig.saveItemsBeforeActionExecute) {
                return $q.when(); //do not attempt to save items if it is not required
            }

            var grid = $scope.orderItemsGrid;

            //TODO: The following code will get the selection only on the current page, so it will work only for the 
            //cases when we have all items shown on the page
            var itemsToUpdateAndSave = _.map(grid.select(), function (x) { return grid.dataItem(x); });

            //We want to save every order item (and its custom fields) before progressing it to the next step (executing action on it)
            //In case order items values were updated
            var itemsSavePromises = [];
            for (var i = 0; i < itemsToUpdateAndSave.length; i++) {
                itemsSavePromises.push(orderItemsRepository.saveOrderItem(itemsToUpdateAndSave[i]));
            }
            $log.debug('About to save to server ' + itemsToUpdateAndSave.length + ' selected items for selected before progressing them / executing workflow action.');

            return $q.all(itemsSavePromises);
        }

    })

    // Separate service for update events (to prevent multiple event subscription)
    .service('orderItemsGridControllerUpdatesService', function (rest) {
        var _this = this;
        var newOrderItemCb;
        var orderItemChangedCb;
        var orderChangedCb;

        rest.events.on("modelCreatedOnServer", function (modelInfo) {
            if (!newOrderItemCb) {
                return;
            }
            if (modelInfo && modelInfo.modelType == "OrderItemModel") {
                newOrderItemCb(modelInfo);
            }
        });

        rest.events.on("modelUpdatedOnServer", function (modelInfo) {
            if (modelInfo.modelType == "OrderItemModel" && orderItemChangedCb) {
                orderItemChangedCb(modelInfo);
            } else if (modelInfo.modelType == "OrderModel" && orderChangedCb) {
                orderChangedCb(modelInfo);
            }
        });

        _this.onNewOrderItem = function (cb) {
            newOrderItemCb = cb;
        };

        _this.onOrderItemChanged = function (cb) {
            orderItemChangedCb = cb;
        };

        _this.onOrderChanged = function (cb) {
            orderChangedCb = cb;
        };

        return _this;
    })

    ;
